<template>
  <div>
    <div class="position-relative mb-3">
      <div class="position-relative mb-3">
        <section class="section-profile-cover section-shaped my-0">
          <div
            class="shape shape-style-1 bg-gradient-darkgray shape-skew alpha-4"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </section>
        <section class="section-skew">
          <div class="container-section">
            <card shadow class="section-home">
              <div class="row row-grid align-items-center">
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 text-right"
                >
                  <div class="title-product">
                    <h3>
                      نرم‌افزار مدیریت پروژه ساتراپ
                    </h3>
                    <p>ساتراپ، داشبورد جامع مدیریت سازمانی</p>
                    <p>
                      سامانه مدیریتی ساتراپ، با ترکیب قدرت و هوشمندی، شما را
                      قادر می‌سازد تا با یک نگاه جامع، سازمان خود را بهینه کرده
                      و به سوی رشد و موفقیت حرکت نمایید.
                    </p>
                  </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="img-main-page">
                    <img src="img/product/Dashboard.svg" alt="" />
                  </div>
                </div>
              </div>
            </card>
          </div>
        </section>
      </div>
      <section class="section-tab-product">
        <div class="container-section">
          <tabs :fill="false" class="flex-column">
            <tab-pane key="tab1" class="section-product">
              <template slot="title">
                <h5>
                  ساتراپ چیست؟
                </h5>
              </template>

              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>نرم‌افزار مدیریت پروژه ساتراپ</h6>
                  <p>ساتراپ، داشبورد جامع مدیریت سازمانی</p>
                  <p>
                    سامانه مدیریتی ساتراپ، با ترکیب قدرت و هوشمندی، شما را قادر
                    می‌سازد تا با یک نگاه جامع، سازمان خود را بهینه کرده و به
                    سوی رشد و موفقیت حرکت نمایید.
                  </p>
                  <p>
                    این داشبورد، اطلاعات حیاتی و کلیدی را از تمامی بخش‌های
                    سازمان جمع‌آوری کرده و در قالب گزارش‌های کاربردی و نمودارهای
                    مختلف و متنوع به شما ارائه می‌دهد. این امر به شما کمک می‌کند
                    تا به طور دقیق و هدفمند، روند کسب و کار خود را رصد نموده و
                    با استفاده از این اطلاعات، عملکرد سازمان خود را در مقایسه با
                    رقبا ارتقا دهید.
                  </p>
                  <p>
                    با استفاده از ساتراپ، می‌توانید به عنوان رهبری هوشمند و
                    بینش‌محور، سازمان خود را به سمت پیشرفت و رشد هدایت کنید. این
                    داشبورد جامع، به شما این امکان را می‌دهد تا برنامه‌ها و
                    استراتژی‌های خود را بهبود بخشیده و تصمیماتی موثرتر‌ اتخاذ
                    نمایید.
                  </p>
                  <p>
                    ساتراپ، به عنوان یک محصول نوآورانه و قدرتمند، به طور ویژه
                    جهت استفاده مدیران و تیم‌های سازمانی طراحی شده است. این
                    داشبورد جامع، با استفاده از فناوری پیشرفته، امکان مدیریت و
                    نظارت کامل بر فعالیت‌ها و عملکردهای سازمان را فراهم می‌سازد.
                    همچنین سامانه مدیریتی این فرصت را در اختیار شما قرار می‌دهد
                    تا تمامی جنبه‌های مهم سازمان از جمله منابع انسانی، مالی،
                    فروش و بازاریابی را در یک بستر واحد تجمیع نموده و نقاط قوت و
                    ضعف سازمان خود را شناسایی نمایید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pl-0"
                >
                  <div class="img-tab">
                    <img src="img/product/productone.svg" alt="" />
                  </div>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab2" class="section-product">
              <template slot="title">
                <h5>
                  ویژگی‌های ساتراپ
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="12"
                  lg="12"
                  md="12"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    ویژگی‌هایی که ساتراپ را به یک سیستم مدیریتی شاخص تبدیل کرده
                    است:
                  </h6>
                  <ul class="list-unstyled list-tab mt-4">
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          آنلاین و مبتنی بر وب
                        </h5>
                      </div>
                      <p class="pt-2">
                        فارغ از زمان و مکان، تمامی امور مربوط به سازمان خود را
                        مدیریت کنید.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          طراحی کاملا واکنش‌گرا (responsive)
                        </h5>
                      </div>
                      <p class="pt-2">
                        بهترین تجربه و رابط کاربری را در تمامی پلتفرم‌ها به
                        ارمغان می‌آورد.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          تعداد نامحدود کاربران
                        </h5>
                      </div>
                      <p class="pt-2">
                        هر سازمانی با هر تعداد اعضا، قادر به استفاده و بهره گیری
                        کامل از این سیستم است.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          طراحی ساده و کاملا کاربر پسند
                        </h5>
                      </div>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          امکان شخصی سازی سیستم متناسب با نیازهای سازمان شما
                        </h5>
                      </div>
                      <p class="pt-2">
                        تمامی راهکارها و ماژول‌های این سیستم متناسب با کسب و کار
                        شما شخصی سازی می‌شوند.
                      </p>
                    </li>
                    <li class="py-2">
                      <div class="d-flex align-items-center">
                        <badge
                          type="darkgray"
                          circle
                          class="ml-3"
                          icon="fa fa-check-circle"
                        ></badge>
                        <h5 class="mb-0">
                          مدیریت امن سطوح دسترسی اعضای سازمان در سیستم ساتراپ
                        </h5>
                      </div>
                      <p class="pt-2">
                        سطوح دسترسی به بخش‌های گوناگون نرم‌افزار را برای هر یک
                        از اعضای سازمان، بر اساس وظایفشان مدیریت کنید و از
                        دسترسی سایر افراد به اطلاعات سازمان خود جلوگیری نمایید.
                      </p>
                    </li>
                  </ul>
                </b-col>
              </b-row>
            </tab-pane>

            <tab-pane key="tab3" class="section-product">
              <template slot="title">
                <h5>
                  ماژول‌های ساتراپ
                </h5>
              </template>
              <b-row>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مدیریت پروژه‌ها</h6>
                  <p>
                    تعریف پروژه، تعریف تسک‌های پروژه‌ و مهلت انجام هر تسک، تخصیص
                    تسک به کارمندان سازمان، پیگیری وضعیت انجام تسک‌های مربوط به
                    هر پروژه و نمایش درصد پیشرفت هر تسک، همگی از امکاناتی هستند
                    که سیستم ساتراپ در اختیار کارکنان شما قرار می‌دهد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>مدیریت منابع انسانی</h6>
                  <p>
                    تمامی فرایندهای مربوط به جذب و استخدام، حقوق و دستمزد،
                    پرسنلی، کارگزینی و صدور احکام، حضور و غیاب و ارزیابی عملکرد
                    کارکنان خود را به صورت یکپارچه مدیریت کنید تا بتوانید به
                    بهترین نحو از توانمندی‌ها و استعدادهای کارکنانتان بهره‌مند
                    شوید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>گزارش‌ساز پیشرفته</h6>
                  <p>
                    با توجه به نیاز سازمان خود در لحظه، از هر بخشی از سیستم،
                    گزارش‌های مختلف و متنوع تهیه کرده و از آن‌ها برای مقایسه،
                    عیب یابی و افزایش بهره‌وری سازمان خود استفاده نمایید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    CRM و مدیریت و دسته‌بندی امور مربوط به مخاطبین سازمان و
                    سازمان‌های همکار
                  </h6>
                  <p>
                    تمامی اطلاعات مشتریان خود، از جمله جزئیات هویتی مشتریان،
                    تاریخچه تعاملات، خریدها، درخواست‌ها و سوابق تراکنش‌های هر
                    مشتری را در یک پایگاه داده مرکزی ذخیره و مدیریت کرده و بر
                    تمامی فرایندهای منوط به ارتباط با مشتریان، نظارت داشته
                    باشید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    مدیریت فرآیند تولید
                  </h6>
                  <p>
                    به صورت سریع و آسان به اطلاعات مرتبط با مدیریت تولید، خط
                    تولید، موجودی مواد اولیه، توزیع و ارتباط میان خط تولید،
                    انبار و خط فروش دسترسی پیدا کنید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    مدیریت استعلام ها و سفارش ها
                  </h6>
                  <p>
                    با دسترسی به تمامی اطلاعات مربوط به استعلام‌ها و سفارش‌های
                    ثبت شده، از جمله وضعیت، تاریخ و جزئیات بیشتر آن‌ها، به صورت
                    سازماندهی شده استعلام‌ها و سفارش‌های مشتریان خود را مدیریت
                    کنید و فرایند ثبت و پیگیری سفارش‌ها را به آسانی و در کمترین
                    زمان انجام دهید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    انبارداری
                  </h6>
                  <p>
                    بهینه سازی و اتوماسیون حداکثری تمامی فرآیندهای مرتبط با
                    مدیریت و کنترل موجودی‌ها و عملیات انبارداری را با استفاده از
                    ماژول انبارداری ساتراپ تجربه کنید. قابلیت اتصال انبارداری
                    ساتراپ به سایر بخش‌های این سیستم مانند مدیریت سفارش‌ها،
                    فروشگاه، خط تولید و... امکان انتقال فراگیر داده‌ها و اطلاعات
                    را برای شما فراهم می‌کنند و هماهنگی بین انبار و سایر بخش‌های
                    سازمان را تسهیل می‌سازد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    دبیرخانه
                  </h6>
                  <p>
                    قابلیت ثبت، اصلاح و ابطال نامه‌های درون سازمانی و میان
                    سازمانی، پیگیری و امضای نامه‌ها، بایگانی نامه‌ها و فرم‌ها و
                    به طور کلی، تمام ابزارهایی که جهت مدیریت نامه‌های سازمان خود
                    احتیاج دارید، در این بخش به طور کامل در اختیارتان قرار خواهد
                    گرفت. این دبیرخانه مجازی شما را از چالش‌های مدیریت نامه‌های
                    کاغذی رها می‌سازد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    چت یا پیام‌رسان سازمانی
                  </h6>
                  <p>
                    چت سازمانی ساتراپ، بستری امن برای ارسال و دریافت پیام به
                    صورت real-time، ایجاد گروه چت‌ و ارسال و دریافت انواع
                    فایل‌ها برای کارکنان شما فراهم می‌کند. امکان برقراری
                    تماس‌های صوتی و تصویری میان کارمندان، جهت برگزاری جلسات با
                    بالاترین کیفیت نیز در این سیستم تعبیه شده است.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    فروشگاه آنلاین
                  </h6>
                  <p>
                    با استفاده از فروشگاه آنلاین ساتراپ، می‌توانید به آسانی و
                    فارغ از محدودیت زمانی و مکانی، کالا و خدمات خود را به
                    مشتریان خود ارائه داده و کسب و کار خود را گسترش دهید. با
                    قابلیت اتصال این فروشگاه به انبارداری این فرصت را برای شما
                    فراهم می‌شود تا بتوانید محصولات خود را به صورت مستقیم و بدون
                    واسطه به دست مشتریان خود برسانید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    مدیریت فروشگاه‌ها
                  </h6>
                  <p>
                    این داشبوردر جهت سهولت مدیریت فروشگاه‌های فیزیکی طراحی شده و
                    شامل مواردی همچون مدیریت موجودی و انبار، درآمد بر اساس
                    بازه‌های زمانی مختلف، انواع گزارش‌های مالی و... است. قابلیت
                    اتصال به سیستم‌های مختلف ساتراپ فراهم شده است.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    تعمیر و نگهداری تجهیزات
                  </h6>
                  <p>
                    سیستم نگهداری و تعمیرات ساتراپ قادر است ضمن فراهم آوردن
                    بستری مناسب جهت ثبت اطلاعات شناسنامه‌ای و فنی ماشین آلات و
                    تجهیزات، برنامه‌ریزی سرویس‌های پیشگیرانه، مدیریت تعمیرات
                    اضطراری و سرویس‌های پیش‌بینانه، به بهبود راندمان تولید و
                    افزایش میزان کارکرد ماشین‎آلات کمک شایانی نماید.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    مدیریت امور شخصی
                  </h6>
                  <p>
                    تمامی امور شخصی خود را به همراه مهلت انجام هر یک در سامانه
                    ثبت و ذخیره کنید و به صورت یکجا به آن‌ها دسترسی داشته باشید.
                    یادآور خودکار سامانه، شما را از نزدیک شدن به مهلت انجام هر
                    تسک مطلع می‌سازد.
                  </p>
                </b-col>
                <b-col
                  cols="12"
                  xl="6"
                  lg="6"
                  md="6"
                  sm="12"
                  xs="12"
                  class="pr-0"
                >
                  <h6>
                    اخبار سازمان
                  </h6>
                  <p>
                    بخش اخبار سازمان، مختص پیام‌ها و اعلان‌هایی است که توسط مدیر
                    سامانه جهت نمایش عمومی انتشار می‌یابند و برای همه یا عده ای
                    خاص از کارکنان سازمان قابل مشاهده هستند.
                  </p>
                </b-col>
              </b-row>
            </tab-pane>
          </tabs>
        </div>
      </section>
    </div>
    <button v-if="showScrollButton" @click="scrollToTop" class="scroll-to-top">
      <i class="fa fa-arrow-up" aria-hidden="true"></i>
    </button>
  </div>
</template>
<script>
import Tabs from "@/components/Tabs/Tabs.vue";
import TabPane from "@/components/Tabs/TabPane.vue";

export default {
  name: "SatrApp",
  components: {
    Tabs,
    TabPane,
  },
  data() {
    return {
      showScrollButton: false,
    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    handleScroll() {
      this.showScrollButton = window.scrollY > 300;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
